import { getLink } from "../../../utils/utils";

import translator from "./translator";

const content = {
  esp: (
    `
    <h4 class="mb-3 bold text-center">Brodita viŝtuko</h4>

    <div class="poem">
      <p class="poem-block mb-3">
        Kara mia patrin’, <br/>
        Ploris vi en doloro, <br/>
        Kaj kondukis vi min <br/>
        Ĝis la kamp’ post vilaĝ’. <br/>
        Por la voj’ malproksima <br/>
        Vi min benis en ruĝa aǔroro, <br/>
        Kaj viŝtukon donacis broditan kun franĝ’, <br/>
        Kaj viŝtukon donacis memfaran, broditan kun franĝ’.
      </p>

      <p class="poem-block refreno mb-3">
        Por feliĉ’, por destin’ <br/>
        Ĝin donacis patrino, <br/>
        Por la bona memor’ <br/>
        Por protekt’ de l’ devi’. <br/>
        Mi ĝin sternos porlonge, <br/>
        Kiel vojon de l’ vivo senfina, <br/>
        Kiel vojon de l’ vivo, donita de vi, <br/>
        Kiel vojon de l’ vivo, donita, patrino, de vi.
      </p>

      <p class="poem-block mb-3">
        Mi rigardos kun am’ <br/>
        La viŝtukon skarlatan, – <br/>
        Eksusuros la herboj <br/>
        Kaj kantos birdar’, – <br/>
        Rememoros sopire <br/>
        Mian hejmon kaj panjon amatan, <br/>
        Vian amon, varmegan kun dolĉa amar’, <br/>
        Vian amon, varmegan, ho panjo, kun dolĉa amar’.
      </p>
    </div>


    <h4 class="mt-5 mb-3 bold text-center">Oj, en ĉeriza ĝardenet’</h4>


    <div class="poem">
      <p class="poem-block mb-3">
        Oj, en ĉeriza ĝardenet’ <br/>
        Aŭdiĝas najtingala kant’. <br/>
        Mi petis lasi hejmen min, <br/>
        Sed min ne lasis la amant’.
      </p>

      <p class="poem-block mb-3">
        Mi estas via por ĉiam, <br/>
        Sed jam proksimas la aǔror’, <br/>
        Revenos mia patrinet’, <br/>
        Ekvidos, ke mi estas for.
      </p>

      <p class="poem-block mb-3">
        Forestis kial, la filin’, <br/>
        Kie pasigis nokton vi? <br/>
        La harplektaĵo en malord’ <br/>
        Kaj en okuloj larma bril’…
      </p>

      <p class="poem-block mb-3">
        La harplektaĵo en malord’ <br/>
        Ĉar amikin’ displektis ĝin, <br/>
        Sed en okuloj larma bril’ <br/>
        Ĉar la amant’ forlasis min.
      </p>
    </div>
    `
  )
}

const itemName = {
  esp: 'Ukrainiaj popolaj kantoj'
}

const item = {
  itemlink: getLink(itemName.esp),
  esp: {
    itemName: itemName.esp,
    itemContent: content.esp,
    itemVideo: ['XTEMDTVGiKE', 'wGL3RxDB4zU'],
    itemTranslator: `
      Teksto: A. Maliŝko, <br/>
      Muziko: P. Majboroda, <br/>
      ${translator.esp}
    `
  }
}

export default item;